<template>
  <!-- prettier-ignore -->
  <div class="header">
    <div class="header-logo">
      <a :href="dotCom">
        <img
          alt="logo"
          :src="logo"
        />
      </a>
    </div>

    <div class="header-debug">
      <template v-if="showHeaderDebugActions">
        <debug-actions class="header__debug" />

        <div
          v-if="basketStore.basket.existingCustomer"
          class="debug__info"
        >
          <the-icon
            v-tooltip="'Existing Customer!'"
            class="fa-beat"
            art="duo"
            name="radiation"
          />
        </div>
      </template>
    </div>

    <div class="header-controls">
      <template v-if="$props.metaOptions.aide">
        <header-aide
          class="header__controls"
          :language="formData.language"
        />
      </template>
      <template v-else>
        <header-dvp
          class="header__controls"
          :language="formData.language"
          :options="$props.metaOptions"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, reactive } from 'vue'

import basketStore from '@/store/basket'
import useI18n from '@/hooks/useI18n'

import DebugActions from '@/components/Container/Header/DebugActions'
import HeaderAide from '@/components/Container/Header/HeaderAide'
import HeaderDvp from '@/components/Container/Header/HeaderDVP'

import logo from '@/assets/logo.svg'

// HOOKS
const { selectedLanguage } = useI18n()

// INIT
defineProps({
  metaOptions: {
    type: Object,
    default: () => {},
  },
})

// DATA
const formData = reactive({
  basket: null,
  language: selectedLanguage.value,
})
const showHeaderDebugActions = ref(import.meta.env.VITE_FEATURE_DEBUG_ACTIONS === '1')

// COMPUTED
const dotCom = computed(() => {
  if (import.meta.env.DEV) {
    return `${window.location.protocol}//${window.location.host}`
  }
  return `${window.location.protocol}//${window.location.host}/${formData.language}`
})
</script>

<style name="mobile" scoped>
.header {
  display: grid;
  grid-template-columns: 61px 35px 1fr;
  grid-template-areas: 'logo debug controls';
  height: 34px;
  max-width: 960px;
  margin: 0 auto;
  padding: 0 16px;

  transition: all 0.35s ease-in-out;
}

.header-logo {
  grid-area: logo;
  align-self: center;

  img {
    height: 15px;
    width: 61px;
  }
}

.header-debug {
  grid-area: debug;
  align-self: center;

  display: flex;
  flex-direction: row;

  .header__debug {
    display: flex;
    align-items: center;
  }

  .debug__info {
    .icon {
      position: absolute;
      font-size: 60px;
      color: rgb(225, 185, 39);
      position: absolute;
      left: calc(50% - 30px);
      top: 0;
    }
  }
}

.header-controls {
  grid-area: controls;
  align-self: center;
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .header {
    grid-template-columns: 124px 35px 1fr;
    height: 64px;
  }

  .header-logo {
    img {
      height: 30px;
      width: 124px;
    }
  }
}
</style>

<style name="dialog">
.insert-box {
  .insert {
    &-message {
      text-align: left;
      margin-bottom: 8px;
    }
    &-button {
      display: flex;
      margin: 10px 10px 10px auto;
    }
  }
}
</style>
